import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-toastr',
  templateUrl: './toastr.component.html',
  styleUrls: ['./toastr.component.scss']
})
export class ToastrComponent implements OnInit {
  @Input() properties!: { type: string, message: string }
  alertProperties!: { type: string, message: string }
  @Output() onClickToast = new EventEmitter<any>();
  @Input() isClickToaskAction!: boolean;

  ngOnInit() {
    this.alertProperties = {
      type: this.properties.type,
      message: this.properties.message
    }
  }

  onClickDiv() {
    this.onChildClick();
  }

  onChildClick() {
    if (this.isClickToaskAction)
      this.onClickToast.emit();
  }
}
